import React  from 'react';
import {
    Form, Button, Select, 
} from 'antd';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required, FieldSelectEditar, FieldSelectRegistro,FieldPassword } from '../../app/inputs/InputField';

const Option = Select.Option;
const validate = values => {
  const errors = {}
  if (!values.username) {
    errors.username = 'Campo requerido'
  } 
  if (!values.email) {
    errors.email = 'Campo requerido'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Correo invalido'
  }
  if (!values.password) {
    errors.password = 'Campo requerido';
  }
  if (!values.password_confirm ) {
    errors.password_confirm = 'Campo requerido' ;
  } else if (values.password_confirm !== values.password) {
    errors.password_confirm = 'Las contraseñas no coinciden';
  }
  return errors
}
let FormAgregarUsuario = props => {

  if(props.usuario){
    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="username" component={InputField} ph="Nombre de usuario" validate={[required]} />
        <Field name="first_name" component={InputField} ph="Nombre" validate={[required]} />
        <Field name="last_name" component={InputField} ph="Apellidos" validate={[required]} />
        <Field name="user_permissions" component={FieldSelectEditar} ph="permisos" validate={[required]} defaultVal={props.usuario.user_permissions}>
            {
            props.permisos && props.permisos.length > 0
              ? props.permisos.map((c, key) => (
                <Option key={c.id} value={c.id}>{c.codename}</Option>
              ))
              : (
                <Option key={1} value={1} >No existen permisos</Option>
              )
           }  
        </Field>
        {/* <Field name="password" component={InputField} ph="Contraseña" validate={[required]} />
        <Field name="password_confirm" component={InputField} ph="Confirmar Contraseña" validate={[required]} />
         */}
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} type="primary" icon="plus" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )

  }
  else {
    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="username" component={InputField} ph="Nombre de usuario" validate={[required]} />
        <Field name="first_name" component={InputField} ph="Nombre" validate={[required]} />
        <Field name="last_name" component={InputField} ph="Apellidos" validate={[required]} />
        <Field name="user_permissions" component={FieldSelectRegistro} ph="Permisos" validate={[required]}  >
            {
            props.permisos && props.permisos.length > 0
              ? props.permisos.map((c, key) => (
                <Option key={c.id} value={c.id}>{c.codename}</Option>
              ))
              : (
                <Option key={1} value={1} >No existen permisos</Option>
              )
           }  
        </Field>
        <Field name="password" component={FieldPassword} ph="Contraseña" validate={[required]} />
        <Field name="password_confirm" component={FieldPassword} ph="Confirmar Contraseña" validate={[required]} />
        
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
  }

    


  }

const mapStateToProps = (state, props) => {
  if(props.usuario)
  {
  return {
    permisos:state.reducerConfig.permisos,
    initialValues: {
      username:props.usuario.username,
      first_name:props.usuario.first_name,
      last_name:props.usuario.last_name,
      user_permissions:props.usuario.user_permissions.map(function(x) {
        return x.id
    }),
  }
  }
  }
  else{
    return {
      permisos:state.reducerConfig.permisos,
      initialValues:props.usuario,
  
    }
  }

 
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 
  }
}
export default connect(mapStateToProps, mapDispatchToProps)( reduxForm({ form: 'FormAgregarUsuario',validate })(FormAgregarUsuario))